import type { AiReportStatus } from "../api/aiReports";

const reportDateFormatter = new Intl.DateTimeFormat("en", {
  timeZone: "Europe/Moscow", year: "numeric", month: "2-digit", day: "2-digit",
});

function calendarDate(date: Date) {
  const parts = reportDateFormatter.formatToParts(date);
  const part = (type: string) => parts.find((item) => item.type === type)!.value;
  return `${part("year")}-${part("month")}-${part("day")}`;
}

// Расписание задаёт дни недели; ночную генерацию считаем отчётом за этот день.
export function getLastScheduledReportDate(days: number[], now = new Date()): string | null {
  const today = new Date(`${calendarDate(now)}T00:00:00Z`);
  for (let offset = 0; offset < 7; offset += 1) {
    const candidate = new Date(today.getTime() - offset * 86_400_000);
    const weekday = candidate.getUTCDay() || 7;
    if (days.includes(weekday)) return candidate.toISOString().slice(0, 10);
  }
  return null;
}

export function getAiReportGenerationReason(status: AiReportStatus, days: number[], now = new Date()) {
  if (!status.has_latest) return "missing";
  const scheduledDate = getLastScheduledReportDate(days, now);
  const updatedAt = status.updated_at ? new Date(status.updated_at) : null;
  if (!scheduledDate || !updatedAt || !Number.isFinite(updatedAt.getTime())) return "unknown";
  return calendarDate(updatedAt) < scheduledDate ? "outdated" : "current";
}
